/**
 * https://css-tricks.com/animating-number-counters/
 */
function animateValue(obj, start, end, duration) {
    if (isNaN(end)) {
        return
    }

    let startTimestamp = null
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp
      const progress = Math.min((timestamp - startTimestamp) / duration, 1)
      obj.innerHTML = Math.floor(progress * (end - start) + start)
      if (progress < 1) {
        window.requestAnimationFrame(step)
      }
    };
    window.requestAnimationFrame(step)
}

window.addEventListener('DOMContentLoaded', () => {
    const keyFigure = document.querySelector('.key-figure')
    let count = 0

    if (!keyFigure) {
        return
    }

    function handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if(entry.isIntersecting){
                if (0 === count) {
                    count += 1
                    const nums = document.querySelectorAll(".key-figure p:first-child")
                    nums.forEach(num => {
                        animateValue(num, 0, num.textContent, 1000)
                    });
                }

                const secondParagraphs = document.querySelectorAll(".key-figure > div p:nth-of-type(2)");
                secondParagraphs.forEach(p => {
                    if (p.style.display === "none" || p.style.display === "") {
                        p.style.display = 'flex';
                        p.classList.add('p-slide-in');
                    }
                });
            }
        });
    }
    const observer = new IntersectionObserver(handleIntersection, {
        threshold: 0.2
    })
    observer.observe(keyFigure)
})
